import { Autocomplete } from "@material-ui/lab";
import { paymentLinkTypePaymentMethods, paymentMethods } from "../../constants";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";

export default function PaymentMethodSelect({ paymentLinkTypeValue, paymentMethod, onChangePaymentMethod = () => {} }) {
  return (
    <FormControl variant="outlined">
      <InputLabel>Método de Pagamento</InputLabel>
      <Select
        value={paymentMethod}
        onChange={(e) => onChangePaymentMethod(e.target.value)}
        label="Método de Pagamento"
      >
        {paymentMethods.map(method => {
          return (
            <MenuItem key={method.id} value={method.id}>
              {method.name}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )

  return (
    <Autocomplete
      multiple
      filterSelectedOptions
      options={paymentLinkTypePaymentMethods[paymentLinkTypeValue]}
      value={paymentMethods}
      onChange={(e, newValues) => onChangePaymentMethods(newValues)}
      getOptionLabel={(option) => option.name}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Selecione o método de pagamento"
        />
      )}
    />
  );
}
